<template>
  <Tippy
    :trigger="tippyTrigger"
    :delay="delay"
    theme="light"
    interactive
    max-width="720"
    flip-on-update="true"
    @show="request"
  >
    <template #trigger>
      <slot />
    </template>

    <Loader v-if="pending" />
    <div
      v-else-if="details"
      class="text-left p-3 popover-content"
      style="width: 700px; max-height: 60vh; overflow-y: auto"
    >
      <PayerHeader
        v-bind="details"
        class="px-0"
        style="font-size: 12px; margin-bottom: 12px; margin-left: -5px"
      />
      <PayerDataSummary
        v-bind="details"
      />
      <template v-if="details.balance && details.balance.some((b) => b.balance !== 0)">
        <h6 class="payer-section mt-3 mb-1">
          {{ $t('payers.balance') }}
        </h6>
        <PayerBalance :balance="details.balance" />
      </template>
      <template v-if="payeeAdmin">
        <h6 class="payer-section mt-3 mb-1">
          {{ $t('billingScopes.billingScopes') }}
        </h6>
        <PayerBalanceHistory
          :payer-id="id"
          :more="moreBalance"
          @more="moreBalance = true"
        />
      </template>
    </div>
  </Tippy>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PayerHeader from './PayerHeader';
import PayerDataSummary from './sections/PayerDataSummary';
import PayerBalance from './sections/PayerBalance';
import PayerBalanceHistory from './sections/PayerBalanceHistory';

export default {
  props: {
    enabled: Boolean,
    id: String,
    trigger: { type: String, default: null },
    delay: { type: [String, Array, Number], default: undefined },
  },
  data: () => ({
    details: null,
    pending: false,
    moreBalance: false,
  }),
  components: {
    PayerHeader,
    PayerDataSummary,
    PayerBalance,
    PayerBalanceHistory,
  },
  computed: {
    ...mapGetters(['payeeAdmin']),
    tippyTrigger() {
      return this.trigger || (this.enabled ? 'click' : 'manual');
    },
  },
  methods: {
    ...mapActions(['getPayerDetails']),
    request() {
      this.pending = true;
      this.getPayerDetails({
        params: {
          payerId: this.id,
          query: {
            withBills: true,
            withActivation: false,
          },
        },
      })
        .then(({ data }) => {
          this.details = data;
          this.$emit('updated', this.details);
        })
        .finally(() => {
          this.pending = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .payer-section {
    font-size: 13px;
    font-weight: 600;
  }

  .popover-content {
    overscroll-behavior: contain;
  }
</style>
